import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import NotFound from '../pages/NotFound';
import EventosPage from '../pages/eventos/page';
import PirotecnicaPage from '../pages/pirotecnica/page';
import VideosPage from '../pages/videos/page';
import CalendarioPage from '../pages/calendario/page';
import MerchandisingPage from '../pages/merchandising/page';
import NosotrosPage from '../pages/nosotros/page';
import ContactoPage from '../pages/contacto/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/eventos',
    element: <EventosPage />
  },
  {
    path: '/pirotecnia',
    element: <PirotecnicaPage />
  },
  {
    path: '/videos',
    element: <VideosPage />
  },
  {
    path: '/calendario',
    element: <CalendarioPage />
  },
  {
    path: '/merchandising',
    element: <MerchandisingPage />
  },
  {
    path: '/nosotros',
    element: <NosotrosPage />
  },
  {
    path: '/contacto',
    element: <ContactoPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
